module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/ultilities/roles/roles.component.html
// module id = ./src/app/ultilities/roles/roles.component.html
// module chunks = main